import { render, staticRenderFns } from "./RectangleShape.vue?vue&type=template&id=2fb88b2a"
import script from "./RectangleShape.vue?vue&type=script&lang=js"
export * from "./RectangleShape.vue?vue&type=script&lang=js"
import style0 from "./RectangleShape.vue?vue&type=style&index=0&id=2fb88b2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports